import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import { useHistory } from 'react-router-dom';
import eventTracker from '../../../../helpers/eventTracker';
import events from '../../events';
import { Arrow, ArrowsContainer } from '../../../../styles/common-styles';
import { Button } from '../../components';
import { goToTop } from '../../../../helpers';

const MMDetails = ({
  misunderstood_materials,
  mmMaterialIndex,
  prevoiousMMHandler,
  nextMMHandler,
  templateColors
}) => {
  const history = useHistory();
  const { main_color } = templateColors;
  const {
    mat_img,
    mat_id,
    mat_cat_header,
    mat_nm,
    mat_cat_description
  } = misunderstood_materials[mmMaterialIndex];

  useEffect(() => {
    eventTracker(
      events.MATERIAL_MISUNDERSTOOD_SCREEN_ITEM_VIEWED,
      { material_id: mat_id }
    );
  }, []);
  return (
    <>
      <DetailsImageContainer>
        <Image
          src={`https://cdn.recyclecoach.com/gallery/${mat_img}`}
          alt={`${mat_nm || 'Misunderstood material'} details`}
          height="340px"
        />
      </DetailsImageContainer>
      <ContextContainer key={mmMaterialIndex}>
        <ContextCategoryHeader>
          {mat_cat_header.replace(/<[^>]+>/g, '')}
        </ContextCategoryHeader>
        <ContextTitle>
          {mat_nm}
        </ContextTitle>
        <MmMaterialDescriptionBody
          key={mmMaterialIndex}
          dangerouslySetInnerHTML={{
            __html:
              mat_cat_description
          }}
        />
      </ContextContainer>
      {mmMaterialIndex === misunderstood_materials.length - 1 && (
        <ButtonWrapper>
          <Button
            style={{}}
            mainColor={main_color || false}
            onClick={() => {
              goToTop();
              history.push('/quiz/mum/0');
            }}
            aria-label="Get Certified"
          >
            {_('education.get_certified')}
          </Button>
        </ButtonWrapper>
      )}
      <ArrowsContainer>
        <Arrow
          disabled={mmMaterialIndex === 0}
          background="#269EE2"
          onClick={prevoiousMMHandler}
          aria-label="Previous Misunderstood Material"
        >
          &#8678;
        </Arrow>
        <Arrow
          disabled={mmMaterialIndex === misunderstood_materials.length - 1}
          background="#269EE2"
          onClick={nextMMHandler}
          aria-label="Next Misunderstood Material"
        >
          &#8680;
        </Arrow>
      </ArrowsContainer>
    </>
  );
};

export default connect((store) => ({
  templateColors: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
}), null)(MMDetails);

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const DetailsImageContainer = styled.div`
  text-align: center;
  animation: ${OpacityAnimation} 0.5s;
`;

const ContextContainer = styled.div`
  display:flex;
  flex-direction: column;
  flex: 1;
  margin-left: 20px !important;
  padding: 10px 0;
  overflow: hidden;
  animation: ${OpacityAnimation} 0.5s;
`;

const ContextCategoryHeader = styled.h2`
  margin: 0 !important;
  padding-bottom: 10px !important;
  font-size: 18px !important;
  color: #387AA8 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: Roboto, sans-serif !important;
`;

const ContextTitle = styled.h3`
  margin: 0 !important;
  font-size: 16px !important;
  color: #404040 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: Roboto, sans-serif !important;
`;

const MmMaterialDescriptionBody = styled.div`
  animation: ${OpacityAnimation} 0.5s;
  color: #404040 !important;

  p, li {
    color: #404040;
    font-size: 16px !important;
    font-family: Roboto, sans-serif !important;
  }

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
    margin: 20px 0 15px;
  }
 
  h1 { font-size: 20px !important;   }
  h2 { font-size: 18px !important;   }
  h3 { font-size: 16px !important;   }
  h4 { font-size: 14px !important;   }
  h5 { font-size: 13px !important;   }
  h6 { font-size: 13px !important;   }
`;

const Image = styled.img`
  max-width: ${({ height }) => `${height}`};
  height: ${({ height }) => `${height}`};
  border-radius: 3px;
  object-fit: cover;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  & button {
    margin: 20px 0;
  }
`;
